import { canSeeTechnicianRoutes } from '@/lib/permissions'
import {
  LayoutDashboard,
  AlertCircle,
  MapPin,
  MapPinned,
  Map,
  Users,
  Wrench,
  MessageSquare,
  Building2,
  Tag,
  Flag,
  Coins,
  Signal,
  FileText,
  FileBarChart,
  User,
  Server,
} from 'lucide-react'

// Nav items filtered by role. Empty `roles` means "any authenticated user".
export const navItems = [
  // El rol "soporte" sólo ve en el menú: Incidencias, Mapa de Incidencias, Salones y Técnicos.
  {
    label: 'Dashboard',
    to: '/dashboard',
    icon: LayoutDashboard,
    roles: ['admin', 'gestor', 'encargado', 'administrativo', 'tecnico'],
  },
  { label: 'Incidencias', to: '/incidents', icon: AlertCircle, roles: [] },
  /*{
    label: 'Tipos de incidencia',
    to: '/incident-types',
    icon: Tag,
    roles: ['admin', 'gestor', 'encargado'],
  },
  {
    label: 'Estados de incidencia',
    to: '/incident-statuses',
    icon: Flag,
    roles: ['admin', 'gestor', 'encargado'],
  },*/
  {
    label: 'Salones',
    to: '/sites',
    icon: Building2,
    // tecnico: solo consulta los salones de sus zonas
    roles: ['admin', 'gestor', 'encargado', 'soporte', 'tecnico'],
  },
  {
    label: 'Zonas',
    to: '/zones',
    icon: MapPinned,
    roles: ['admin', 'gestor'],
  },
  {
    label: 'Mapa Incidencias',
    to: '/logistics',
    icon: Map,
    roles: ['admin', 'gestor', 'encargado', 'administrativo', 'soporte'],
  },
  {
    label: 'Técnicos',
    to: '/technicians',
    icon: Wrench,
    roles: ['admin', 'soporte'],
  },
  {
    label: 'Gestión de Rutas',
    to: '/technician-routes',
    icon: MapPin,
    roles: ['admin', 'gestor', 'encargado', 'administrativo'],
    // Ya no son sólo técnicos: con el permiso de seguimiento activado puede
    // llevar ruta cualquier rol. El técnico jefe de zona ve las de su zona.
    can: canSeeTechnicianRoutes,
  },
  {
    label: 'Usuarios',
    to: '/users',
    icon: Users,
    roles: ['admin', 'gestor', 'encargado', 'administrativo'],
  },
  {
    label: 'Mensajes',
    to: '/messages',
    icon: MessageSquare,
    roles: ['admin', 'gestor', 'encargado', 'administrativo'],
  },
  {
    label: 'Importación Máquinas',
    to: '/machines-preview',
    icon: Server,
    roles: ['admin', 'gestor'],
  },
  {
    label: 'Recaudación',
    to: '/recaudacion',
    icon: Coins,
    roles: ['admin', 'administrativo'],
  },
  {
    label: 'Informes',
    to: '/reports',
    icon: FileBarChart,
    roles: ['admin', 'gestor'],
  },
  { label: 'Logs', to: '/logs', icon: FileText, roles: ['admin'] },
  //{ label: 'Mi perfil', to: '/profile', icon: User, roles: [] },
]

// Acepta el usuario entero (preferido) o el slug del rol. Un item puede además
// declarar `can(user)` para permisos que no son un rol.
export const filterNavByRole = (items, userOrRole) => {
  const isSlug = typeof userOrRole === 'string'
  const user = isSlug ? { role: userOrRole } : userOrRole
  const role = isSlug ? userOrRole : userOrRole?.role

  if (!role) return []
  return items.filter(
    (i) =>
      (typeof i.can === 'function' && i.can(user)) ||
      i.roles.length === 0 ||
      i.roles.includes(role)
  )
}
